
import React from 'react';

const countryFlagUrl = (countryCode: string) => {
  return `https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`;
};

interface CountryFlagProps {
  countryCode: string;
  className?: string;
}

const CountryFlag = ({ countryCode, className = "" }: CountryFlagProps) => {
  if (!countryCode) return null;
  
  return (
    <img 
      src={countryFlagUrl(countryCode)} 
      alt={`${countryCode} flag`}
      className={`inline-block object-cover rounded-sm border border-gray-200 shadow-sm ${className}`}
      loading="lazy"
    />
  );
};

export default CountryFlag;
